/**
 * FormPreview 组件的 emit 事件声明
 */
export const emits = [
  /** 底部按钮点击事件 */
  'button-click',
];

